function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.20710678,0.792893219 L8,6.585 L13.7928932,0.792893219 C14.1533772,0.432409257 14.7206082,0.404679722 15.1128994,0.709704612 L15.2071068,0.792893219 C15.5976311,1.18341751 15.5976311,1.81658249 15.2071068,2.20710678 L15.2071068,2.20710678 L9.415,8 L15.2071068,13.7928932 C15.5976311,14.1834175 15.5976311,14.8165825 15.2071068,15.2071068 C14.8165825,15.5976311 14.1834175,15.5976311 13.7928932,15.2071068 L8,9.415 L2.20710678,15.2071068 C1.84662282,15.5675907 1.27939176,15.5953203 0.887100557,15.2902954 L0.792893219,15.2071068 C0.402368927,14.8165825 0.402368927,14.1834175 0.792893219,13.7928932 L0.792893219,13.7928932 L6.585,8 L0.792893219,2.20710678 C0.402368927,1.81658249 0.402368927,1.18341751 0.792893219,0.792893219 C1.18341751,0.402368927 1.81658249,0.402368927 2.20710678,0.792893219 Z"
})));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.76ae8daf.svg";
export { ForwardRef as ReactComponent };